var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.99902,
    y: 3.0498,
    width: 10,
    height: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0198 0H2.97826C1.33481 0 -0.000976562 1.33578 -0.000976562 2.97923V16.5208C-0.000976562 18.1642 1.33481 19.5 2.97826 19.5H23.0198C24.6632 19.5 25.999 18.1642 25.999 16.5208V2.97923C25.999 1.33578 24.6632 0 23.0198 0ZM8.12404 4.33325C9.61693 4.33325 10.8323 5.54883 10.8323 7.04172C10.8323 8.53441 9.61693 9.74998 8.12404 9.74998C6.63115 9.74998 5.41577 8.53441 5.41577 7.04172C5.41577 5.54883 6.63115 4.33325 8.12404 4.33325ZM12.999 14.3542C12.999 14.8027 12.635 15.1667 12.1865 15.1667H4.06152C3.61302 15.1667 3.24902 14.8027 3.24902 14.3542V13.8125C3.24902 12.169 4.58481 10.8333 6.22826 10.8333H10.0198C11.6632 10.8333 12.999 12.169 12.999 13.8125V14.3542ZM21.9365 15.1667H15.9783C15.5298 15.1667 15.1658 14.8027 15.1658 14.3542C15.1658 13.9057 15.5298 13.5417 15.9783 13.5417H21.9365C22.385 13.5417 22.749 13.9057 22.749 14.3542C22.749 14.8027 22.385 15.1667 21.9365 15.1667ZM21.9365 10.8333H15.9783C15.5298 10.8333 15.1658 10.4693 15.1658 10.0208C15.1658 9.57225 15.5298 9.20825 15.9783 9.20825H21.9365C22.385 9.20825 22.749 9.57225 22.749 10.0208C22.749 10.4693 22.385 10.8333 21.9365 10.8333ZM21.9365 6.5H15.9783C15.5298 6.5 15.1658 6.136 15.1658 5.6875C15.1658 5.239 15.5298 4.875 15.9783 4.875H21.9365C22.385 4.875 22.749 5.239 22.749 5.6875C22.749 6.136 22.385 6.5 21.9365 6.5Z",
    fill: "#07C180"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.c2745abf070415f81e58cd394a0d6316.svg";
export { ForwardRef as ReactComponent };